import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { getNodeHighlightedEdges } from './helpers/getNodeHighlightedEdges';
import { unhighlightEdges } from './unhighlightEdges';

export const hideHighlightedEdges: GraphCommandFactory =
  (cmdContext, dispatch) => () => {
    const { pathlookup } = cmdContext.getState();
    const { activeNodeSn, highlightedEdges } = pathlookup.pathInspector;

    const nodeHighlightedEdges = getNodeHighlightedEdges(
      activeNodeSn,
      highlightedEdges,
    );
    if (nodeHighlightedEdges !== undefined) {
      dispatch(unhighlightEdges, {
        color: true,
        edges: [
          ...nodeHighlightedEdges.incomingEdges,
          ...nodeHighlightedEdges.outgoingEdges,
        ],
      });
    }
  };
